export const environment = {
  production: false,
  bundleId: 'fr.craf2s.admin',
  url: 'https://test.admin.link-up.fr/',
  useEmulators: false,
  firebase: {
    apiKey: 'AIzaSyC9DXPc5FcbDbfeSLVHjzY9ODHV_CBtRgw',
    authDomain: 'craf2s-dev.firebaseapp.com',
    projectId: 'craf2s-dev',
    storageBucket: 'craf2s-dev.appspot.com',
    messagingSenderId: '383651297268',
    appId: '1:383651297268:web:029ece3d724b04229b6ba1',
  },
};
